module.exports = __webpack_public_path__ + "img/exit_to_app.31b76ebf.svg";